import React from 'react';

const Input = ({
  type = 'text',
  name,
  rows = 1,
  value,
  onChange,
  label,
  placeholder,
  error,
  required = false,
  highlightRequired = true,
  className = '',
}) => {
  const baseStyles = 'px-4 py-2 rounded-lg border bg-gray-weakest text-gray-strongest border-gray-less placeholder-gray-more focus:ring-2 focus:ring-blue-more focus:border-transparent outline-none transition-colors text-sm flex-grow';

  const errorStyles = 'border-red-mid focus:ring-red-mid';

  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={name}
          className="block text-sm font-medium text-gray-strong mb-1"
        >
          {label}{(highlightRequired && required) && <span> *</span>}
        </label>
      )}
      {rows > 1 ? (
        <textarea
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          className={`${baseStyles} ${error ? errorStyles : ''} ${className} resize-none`}
          rows={rows}
        />
      ) : (
        <input
          id={name}
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          className={`${baseStyles} ${error ? errorStyles : ''} ${className}`}
        />
      )}
      {error && (
        <p className="mt-1 text-sm text-red-more">
          {error}
        </p>
      )}
    </div>
  );
};

export default Input;
